import React, { useContext } from 'react'

import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'
import TitledSelector from '../../../../Components/institution/Quotas/allocation/TitledSelector'
import InstitutionSchoolsList from './InstitutionSchoolsList'
import { InstitutionContext } from '../../../../Providers/InstitutionProvider'

const TITLED_SELECTOR_STYLE = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginBottom: '10px'
}

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const Settings = ({ schools, onSelectSchool, onSelectSector, t }) => {
  const { sectors } = useContext(InstitutionContext)

  return (
    <div className='settings pd-12'>
      <TitledSelector
        style={TITLED_SELECTOR_STYLE}
        data={sectors}
        dataKey='name'
        title={t('Care unit')}
        placeholder={t('Choose a care unit')}
        onDataSelected={onSelectSector}
      />
      <div style={{ height: 'calc(100% - 145px)' }}>
        <InstitutionSchoolsList selected={schools.map(s => s.id)} onSelect={onSelectSchool} />
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(Settings)
